import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PlantService {

  constructor(
    private http: HttpClient
  ) { }

  getPlantOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/plant/getPlantOption`;
    return this.http.get(url);
  }

  getVendorPlantOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/plant/getVendorPlantOptions`;
    return this.http.get(url);
  }

}
